import { render } from "./Resume_refresh.vue?vue&type=template&id=f2f78766&scoped=true&ts=true"
import script from "./Resume_refresh.vue?vue&type=script&lang=ts"
export * from "./Resume_refresh.vue?vue&type=script&lang=ts"

import "./Resume_refresh.vue?vue&type=style&index=0&id=f2f78766&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2f78766"]])

export default __exports__